import * as React from 'react';
import {useSelector} from 'react-redux';

import {EmailSequenceTemplateGroups} from 'nutshell-core/email-sequence-template-groups';

import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconReportsIconOld} from 'shells/icon/svg/sidebar-icon-reports-old';

import {useDismissibleUserSetting} from '../../../util/hooks/use-dismissible-user-setting';

import {useGetSessionUser} from '../../core/use-get-session-user';

export function TemplateGroupsViaEmailReportCta() {
    const emailSequenceTemplateGroups = useSelector((state) =>
        EmailSequenceTemplateGroups.getAll(state)
    );
    const {user} = useGetSessionUser();
    const {shouldShow, onDismiss} = useDismissibleUserSetting(
        'hide_template_groups_via_email_report'
    );

    if (
        shouldShow &&
        user &&
        user.permissions.canManageEmailTemplates &&
        !emailSequenceTemplateGroups.length
    ) {
        return (
            <div style={{padding: '0 16px 16px 16px'}}>
                <CTABanner
                    icon={SidebarIconReportsIconOld}
                    title='Want to get more out of this email report?'
                    text='Organize your team’s templates into groups to report on them here.'
                    buttonText='View email templates'
                    href='/email/templates'
                    newTab={true}
                    onDismiss={onDismiss}
                />
            </div>
        );
    }

    return null;
}
